angular.module('zc.projects')
  .controller('MenuController', MenuController);

MenuController.$inject = ['Devise', 'currentProject'];
function MenuController(Devise, currentProject) {
  const vm = this;

  vm.showsExcludePageType = currentProject.shows_no_publish_page_type;
  vm.enableServiceLens = currentProject.enable_service_lens;
  vm.isMaster = Devise.isMaster();
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/menu.controller.js